import { namespace } from 'vuex-class';
import { IChatState } from './chat.types';

export const chatNamespace = 'chat';
export const ChatNamespace = namespace(chatNamespace);

export function getDefaultState(): IChatState {
  return {
    isLoading: false,
    comments: [],
    commentsRead: null,
    isOpen: false,
    systemMessageOpen: false,
  };
}

export enum EChatAction {
  LoadChat = 'loadChat',
  LoadChatSuccess = 'loadChatSuccess',
  LoadChatFailed = 'loadChatFailed',
  AddComment = 'addComment',
  SetIsOpen = 'setIsOpen',
  ReadComments = 'readComments',
  SetInitialReadComments = 'setInitialReadComments',
  AutoComment = 'autoComment',
  SetSystemMessageOpen = 'setSystemMessageOpen',
  SetChatMessages = 'setChatMessages',
}

export enum EChatMutation {
  SetLoading = 'setLoading',
  SetChatMessages = 'setChatMessages',
  SetIsOpen = 'setIsOpen',
  SetCommentsRead = 'setCommentsRead',
  SetSystemMessageOpen = 'setSystemMessageOpen',
}

export enum EChatGetter {
  Participants = 'participants',
  Messages = 'messages',
  NumUnreadComments = 'numUnreadComments',
}
